export default __webpack_public_path__ + "static/media/icon_copy.195e0c62.svg";